// extracted by mini-css-extract-plugin
module.exports = {"icon":"ButtonIcon_icon__1hsmb","inverted":"ButtonIcon_inverted__3Q7R_"};